import React from "react";
import { Segment, Header } from "semantic-ui-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/pro-regular-svg-icons";
import "./SubmittingPermit.scss";

// General component that shows a styled loading state that their application is submitting a permit.
export const SubmittingPermit = ({ active }: any) => {
  return (
    <div style={{ display: active ? "block" : "none" }}>
      <Segment padded color='orange' className='submitting-permit'>
        <Header as='h2' content='Submitting Your Application...' />
        <FontAwesomeIcon icon={faSpinner} spin size='3x' />
      </Segment>
    </div>
  );
};

export default SubmittingPermit;
